import React from "react";
import { useParams } from "react-router-dom";
import Instruction from /* webpackChunkName: "guide" */ "./Instruction";
import InstructionsRoot from /* webpackChunkName: "guide" */ "./InstructionsRoot";

export default function Instructions() {
  const { type } = useParams();
  return type ? <Instruction type={type} /> : <InstructionsRoot />;
}
